import { render, staticRenderFns } from "./WHeaderBtn.vue?vue&type=template&id=27f8be3d&"
import script from "./WHeaderBtn.vue?vue&type=script&lang=ts&"
export * from "./WHeaderBtn.vue?vue&type=script&lang=ts&"
import style0 from "./WHeaderBtn.vue?vue&type=style&index=0&id=27f8be3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports